import { X, Download, ArrowLeft, GraduationCap } from "lucide-react";
import type { Step } from "../types";

interface ModalHeaderProps {
  isDark: boolean;
  step: Step;
  onStepChange: (step: Step) => void;
  onDownloadPDF: () => void;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  isDark,
  step,
  onStepChange,
  onDownloadPDF,
  onClose,
}) => {
  const isPreview = step === "preview";

  return (
    <div
      className="no-print px-4 sm:px-6 py-3 sm:py-4 border-b flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0"
      style={{
        borderColor: "var(--border-color)",
        backgroundColor: "var(--bg-secondary)",
      }}
    >
      <div className="flex items-center gap-3 w-full sm:w-auto">
        <div
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shrink-0 shadow-sm"
          style={{ backgroundColor: "rgba(25, 103, 210, 0.1)" }}
        >
          <GraduationCap
            className="w-6 h-6 sm:w-7 sm:h-7"
            style={{ color: "var(--primary-color)" }}
          />
        </div>
        <div className="min-w-0 flex-1">
          <h2
            className="text-lg sm:text-xl font-bold truncate tracking-tight"
            style={{ color: "var(--text-primary)" }}
          >
            {isPreview
              ? "Prévisualização da Atividade"
              : "Gerador de Atividades com IA"}
          </h2>
          <p
            className="text-[12px] sm:text-sm truncate"
            style={{ color: "var(--text-secondary)" }}
          >
            {isPreview
              ? "Confira o conteúdo gerado"
              : "Crie atividades e avaliações inteligentes alinhadas à BNCC"}
          </p>
        </div>
        <button
          onClick={onClose}
          className="sm:hidden p-2 rounded-lg transition-all hover:bg-(--bg-accent)"
          style={{ color: "var(--text-secondary)" }}
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
        {isPreview && (
          <>
            <button
              onClick={() => onStepChange("form")}
              className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg transition-all hover:bg-(--bg-accent) text-sm font-medium"
              style={{
                color: "var(--text-secondary)",
              }}
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Voltar</span>
            </button>
            <button
              onClick={onDownloadPDF}
              className="flex items-center gap-2 px-4 sm:px-6 py-2 text-white font-bold rounded-lg hover:opacity-90 transition-all shadow-sm text-sm"
              style={{ backgroundColor: "var(--primary-color)" }}
            >
              <Download className="w-4 h-4" />
              <span>Baixar PDF</span>
            </button>
          </>
        )}

        <button
          onClick={onClose}
          className="hidden sm:block p-2 rounded-lg transition-all hover:bg-(--bg-accent)"
          style={{ color: "var(--text-secondary)" }}
        >
          <X className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};
